import { isDatabookRetryPage } from "./lib/databookRetryToken";
import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

if (import.meta.env.PROD && !isDatabookRetryPage) {
  Sentry.init({
    dsn: "https://730ee91387c990f189e63e264d43dd82@o4510872741216256.ingest.us.sentry.io/4510979022127104",
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "production",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      /^\/api\//,
      /^https:\/\/api\.dill-y\.com\/api\//,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
